
import { ContratoRenegociacao } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { ContratoItem } from './contrato-item.model';

export class ContratoRenegociacaoItem extends BaseResourceModel {
  constructor(
    public valor_unitario_enviado?: number,
    public valor_unitario_recebido?: number,
    public quantidade?: number,
    public contrato_enviado_item?: ContratoItem,
    public contrato_recebido_item?: ContratoItem,
    public saldo?: number,
    public renegociacao?: ContratoRenegociacao,
  ) {
    super();
  }
  static converteJson(json: any): ContratoRenegociacaoItem {
    return Object.assign(new ContratoRenegociacaoItem(), json);
  }
}
